/**
     * Open PO Report
     * This panel use to get the report of all Open PO's  
     * Author: Venkat
     * 
     * */
/**
 * OPO_PC_01
 * importing action,store and SDIconstants,translation, jquery,component router
 * */
import React, { Component } from 'react';
import * as $ from 'jquery';
import * as MenuAction from '../actions/MenuAction';
import * as OpenPOReportAction from '../actions/OpenPOReportAction';
import OpenPOReportStore from '../stores/OpenPOReportStore';
import SDIConstants from '../SDIConstants';
import * as CookieService from '../CookieService';
import { withTranslation, Trans } from 'react-i18next'
import ReactPaginate from 'react-paginate';
import DatePicker from "react-datepicker";
import Select from 'react-select';
import swal from 'sweetalert';
let currentPagePath;

class OpenPOReportComponent extends Component {
    constructor(props) {
        super(props);
        /**
    * OPO_PC_03
    * intilize the variable used in this component
    * */
        this.state = {
            GridData: [],
            PageNo: "1",
            SelectedReport: "X",
            FromDate: "",
            ToDate: "",
            SearchBy: "PO Number",
            SearchCriteria: "",
            ExportToExcel: [],
            PopupVendorDetail: [],
            UseDateRangeCheckbox: false,
            DataLimitCheckbox: false,
            POID: "",
            isFavorited: false,
            PageCount: 0,
            totalCount: 0,
            ShowGrid: false
        }
        this.GoButtonClickResposne = this.GoButtonClickResposne.bind(this);
        this.GetVendorInfoResposne = this.GetVendorInfoResposne.bind(this);
        this.FileExport = this.FileExport.bind(this);
    }
    /**
    * OPO_PC_04
    * */
    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        OpenPOReportAction.getCurrentFavPage(getFavPageBO);
        /*[04/29/22,PC_WW-393_10], Priyanka D */
        this.BuildShipTODD();

        OpenPOReportStore.on("GetOpenPOResponse", this.GoButtonClickResposne);
        OpenPOReportStore.on("GetVendorInfoResposne", this.GetVendorInfoResposne);
        OpenPOReportStore.on('favpage', this.loadFavPageResponse.bind(this));
        OpenPOReportStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
        OpenPOReportStore.on('Export', this.FileExport);
        /*[04/29/22,PC_WW-393_14], Priyanka D */
        OpenPOReportStore.on('ShipToresponse', this.BindShipTO);
    }

    componentWillMount() {
        OpenPOReportStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        OpenPOReportStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));
        OpenPOReportStore.removeListener('Export', this.FileExport);
        //OpenPOReportStore.removeListener('ShipToresponse', this.BindShipTO());
    }
    /*[04/29/22,PC_WW-393_10], Priyanka D */
    BuildShipTODD = () => {

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let ShipToBo = {
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
        }
        OpenPOReportAction.BindShipTo(ShipToBo)
    }
    BindShipTO = () => {
       
        let Shiptoreponse = JSON.parse(OpenPOReportStore.ShipToresponse)
        let ShipToArray = Shiptoreponse.Table;
        let Shiptodropdown = [];
        ShipToArray.map((val, index) => {
            /*PC_WW_723_01 - To display the Default select option - 18/08/23 - Vishwa S*/

            if (index == 0) {
                let localArray = {
                    value: "X",
                    label: "Select Ship To",
                }
                Shiptodropdown.push(localArray)
            }
            let localArray = {
                value: val.LOCATION,
                label: val.LOCATION, //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
            }
            Shiptodropdown.push(localArray)
        });
        console.log("Shiptodropdown", Shiptodropdown)
        this.setState({ ShipToDropdown: Shiptodropdown });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    handleShipTo = (e) => {
        this.setState({ selectedShipTo: e })
        this.setState({ ShowGrid: false, totalCount: 0, GridData: [] });
    }
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(OpenPOReportStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        if (OpenPOReportStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(OpenPOReportStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(OpenPOReportStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
    };

    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "OpenPO Report",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            OpenPOReportAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            OpenPOReportAction.deleteFavPage(deleteFavPageBO)
        }
    };
    /**
     * OPO_PC_07
     * */
    GoButtonClickResposne = () => {

        let Response = JSON.parse(OpenPOReportStore.GetOpenPOResponse);
        if (Response.OpenPOReport != "") {
            let tot = Response.OpenPOReport.length
            let count = parseFloat(Response.OpenPOReport.length) / 10
            if (tot == 300) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "**Warning - results greater than 300 lines...\nOnly the first 300 lines are returned.\n Please limit your results by changing your\n 'Select Report' option."
                });
                // alert("**Warning - results greater than 300 lines...\nOnly the first 300 lines are returned. Please limit your results by\n changing your 'Select Report' option.")
            }
            this.setState({ GridData: Response.OpenPOReport, totalCount: tot, PageCount: count, PageNo: "1" });

        }
        else {
            this.setState({ GridData: [], totalCount: 0, PageCount: 0 });
        }
    }
    /**
    * OPO_PC_12
    * */
    GetVendorInfoResposne = () => {
      
        let Response = JSON.parse(OpenPOReportStore.GetVendorInfoResposne);
        if (Response.vendorInfoDetails != "") {
            this.setState({ PopupVendorDetail: Response.vendorInfoDetails[0] });
            $('#VendorDetail').modal('show');
        }
    }

    /*PC_WW_723_04 - To clear the selected dropdown options - 18/08/23 - Vishwa S*/
    DDClear = () => {
       
        let localArray = {
            value: "X",
            label: "Select Ship To",
        }
        this.setState({ SelectedReport: "X", selectedShipTo: localArray });
        this.setState({ ShowGrid: false, totalCount: 0, GridData: [] });    /*PC_WW_723_08 - To hide the grid, pagenation and number of records - 23/08/23 - Vishwa S*/
    }

    SearchCriteriaCheck = () => {
       
        //TFS-4041-Priyanka-Either shipto or duration should be selected
        /*PC_WW_723_06 - To check if value of selectedShipTo is equal to "X" - 18/08/23 - Vishwa S*/
        if (this.state.SelectedReport == "X" && (this.state.selectedShipTo == null || this.state.selectedShipTo == undefined || this.state.selectedShipTo == "" || this.state.selectedShipTo.value == "X")) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select date range or ship to"
            });
        }
        else if (this.state.SelectedReport == "X") {
            this.GoButtonClick()
            this.setState({ ShowGrid: true });
        }
        else if (this.state.SelectedReport != "99") {
            this.GoButtonClick()
            this.setState({ ShowGrid: true });
        }
        else {
            if (this.state.SearchCriteria != "") {
                if (this.state.UseDateRangeCheckbox == true) {
                    if (this.state.FromDate == "" || this.state.ToDate == "") {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Enter valid date"
                        });
                        // alert("Enter valid date")
                        return
                    }
                    else {
                        let months;
                        months = (new Date(this.state.ToDate).getDate() - new Date(this.state.FromDate).getDate()) / 30 +
                            new Date(this.state.ToDate).getMonth() - new Date(this.state.FromDate).getMonth() +
                            (12 * (new Date(this.state.ToDate).getFullYear() - new Date(this.state.FromDate).getFullYear()));

                        if (months <= 6) {
                            this.GoButtonClick()
                            this.setState({ ShowGrid: true });
                        }
                        else {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Enter date range within 6 months"
                            });
                            // alert("Enter date range within 6 months")
                            return
                        }

                    }
                }
                else {
                    this.GoButtonClick()
                    this.setState({ ShowGrid: true });

                }
            }
            else if (this.state.SearchCriteria == "" && this.state.FromDate == null && this.state.ToDate == null) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Enter any criteria"
                });
                // alert("Enter any criteria")
                return
            }
            else if (this.state.FromDate == "" || this.state.ToDate == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Enter valid date"
                });
                // alert("Enter valid date")
                return
            }
            else if (this.state.FromDate != "" || this.state.ToDate != "") {
                let months;
                months = (new Date(this.state.ToDate).getDate() - new Date(this.state.FromDate).getDate()) / 30 +
                    new Date(this.state.ToDate).getMonth() - new Date(this.state.FromDate).getMonth() +
                    (12 * (new Date(this.state.ToDate).getFullYear() - new Date(this.state.FromDate).getFullYear()));

                if (months <= 3) {
                    this.GoButtonClick()
                    this.setState({ ShowGrid: true });
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Enter date range within 3 months"
                    });
                    // alert("Enter date range within 3 months")
                    return
                }
            }

        }
    }
    /**
     * OPO_PC_10
     * */
    handledate = (date) => {
        if (date != null) {
            return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
        }
    }
    /**
    * OPO_PC_06
    * */
    GoButtonClick = () => {

        let From = this.state.FromDate
        let To = this.state.ToDate
        if (this.state.SelectedReport == "99") {
            if (this.state.FromDate != "" && this.state.ToDate != "") {
                From = this.handledate(this.state.FromDate);
                To = this.handledate(this.state.ToDate);
            }
        }
        let BO = {
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
            Session_SmallSite: CookieService.getLocalStorageValues("Session_SmallSite"),
            txtSearchCriteria: this.state.SearchCriteria,
            dropSearchBy: this.state.SearchBy,
            Report: this.state.SelectedReport,
            FromDate: From,
            ToDate: To,
            usedate: this.state.UseDateRangeCheckbox,
            DataLimit: this.state.DataLimitCheckbox,
            /*PC_WW_723_02 - To check if selectedShipTo is not equal to "X" - 18/08/23 - Vishwa S*/
            ShipTo: (this.state.selectedShipTo != null && this.state.selectedShipTo != undefined && this.state.selectedShipTo.value != "X" ? this.state.selectedShipTo.value : "")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        OpenPOReportAction.GetOpenPODetails(BO);

    }
    /**
    * OPO_PC_08
    * */
    OnHandleChange = (e, name, select) => {
       
        switch (name) {
            case "SearchBy": {
                e.preventDefault();
                this.setState({ SearchBy: select });
                break;
            }
            case "SelectedReport": {
                e.preventDefault();
                this.setState({
                    [name]: e.target.value.trim(), SearchBy: "PO Number",
                    SearchCriteria: "",
                    FromDate: "",
                    ToDate: "",
                });
                this.setState({ ShowGrid: false, totalCount: 0, GridData: [] });
                break;
            } case "SearchCriteria": {
                e.preventDefault();
                this.setState({ [name]: e.target.value.trim() });
                break;
            }
            case "FromDate": case "ToDate": {
                this.setState({ [name]: e });
                this.setState({ ShowGrid: false, totalCount: 0, GridData: [] });
                break;
            }
            case "UseDateRangeCheckbox": {
                this.setState({ UseDateRangeCheckbox: this.state.UseDateRangeCheckbox == true ? false : true });
                break;
            }
            case "DataLimit": {
                this.setState({ DataLimitCheckbox: this.state.DataLimitCheckbox == true ? false : true });
                break;
            }
        }
    }

    handlePageClick = (e) => {
        let pageNo = e.selected + 1;
        this.setState({ PageNo: pageNo });
    }
    //This Method is used to close and open the accordian
    onAccordianClick = (event, index) => {
        $(event.currentTarget).children().toggleClass('accordion-arrow-change');
        $(`#contentrow-${index}`).toggleClass('d-none');
        $('tr').removeClass('tr-border');
        $(event.currentTarget).parent('tr').addClass('tr-border');

    };
    /**
    * OPO_PC_09
    * */
    export = () => {
        let From = this.state.FromDate
        let To = this.state.ToDate
        if (this.state.SelectedReport == "99") {
            if (this.state.FromDate != "" && this.state.ToDate != "") {
                From = this.handledate(this.state.FromDate);
                To = this.handledate(this.state.ToDate);
            }
        }
        let BO = {
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
            Session_SmallSite: CookieService.getLocalStorageValues("Session_SmallSite"),
            txtSearchCriteria: this.state.SearchCriteria,
            dropSearchBy: this.state.SearchBy,
            Report: this.state.SelectedReport,
            FromDate: From,
            ToDate: To,
            usedate: this.state.UseDateRangeCheckbox,
            DataLimit: this.state.DataLimitCheckbox,
            /*PC_WW_723_03 - To check if selectedShipTo is not equal to "X" - 18/08/23 - Vishwa S*/
            ShipTo: (this.state.selectedShipTo != null && this.state.selectedShipTo != undefined && this.state.selectedShipTo.value != "X" ? this.state.selectedShipTo.value : "")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        OpenPOReportAction.ExportData(BO);
    }
    /**
    * OPO_PC_11
    * */
    getVendorInfo = (value) => {
        let BO = {
            Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
            PO_ID: value.PO_ID
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        OpenPOReportAction.GetVendorInfo(BO);
    }
    //TFS-4040-Priyanka-Should not sort  between same values
    Sorting = (sort, name) => {
        let data = []
        if (sort == "A") {
            switch (name) {
                case "PO_ID": {
                    data = this.sort(this.state.GridData, "Arr[i].PO_ID", "Arr[j].PO_ID", "ASC")
                    //data = this.state.GridData.sort((a, b) => (a.PO_ID > b.PO_ID) ? 1 : -1);
                    break;
                }
                case "REQ_ID": {
                    data = this.sort(this.state.GridData, "Arr[i].REQ_ID", "Arr[j].REQ_ID", "ASC")
                    //data = this.state.GridData.sort((a, b) => (a.REQ_ID > b.REQ_ID) ? 1 : -1);
                    break;
                }
                case "SHIPTO_ID": {
                    data = this.sort(this.state.GridData, "Arr[i].SHIPTO_ID", "Arr[j].SHIPTO_ID", "ASC")
                    //data = this.state.GridData.sort((a, b) => (a.SHIPTO_ID > b.SHIPTO_ID) ? 1 : -1);
                    break;
                }
                case "ISA_WORK_ORDER_NO": {
                    data = this.sort(this.state.GridData, "Arr[i].ISA_WORK_ORDER_NO", "Arr[j].ISA_WORK_ORDER_NO", "ASC")
                    // data = this.state.GridData.sort((a, b) => (a.ISA_WORK_ORDER_NO > b.ISA_WORK_ORDER_NO) ? 1 : -1);
                    break;
                }
                case "ISA_EMPLOYEE_NAME": {
                    data = this.sort(this.state.GridData, "Arr[i].ISA_EMPLOYEE_NAME", "Arr[j].ISA_EMPLOYEE_NAME", "ASC")
                    // data = this.state.GridData.sort((a, b) => (a.ISA_EMPLOYEE_NAME > b.ISA_EMPLOYEE_NAME) ? 1 : -1);
                    break;
                }
                case "INV_ITEM_ID": {
                    data = this.sort(this.state.GridData, "Arr[i].INV_ITEM_ID", "Arr[j].INV_ITEM_ID", "ASC")
                    // data = this.state.GridData.sort((a, b) => (a.INV_ITEM_ID > b.INV_ITEM_ID) ? 1 : -1);
                    break;
                }
            }
        }
        else {
            switch (name) {
                case "PO_ID": {
                    data = this.sort(this.state.GridData, "Arr[i].PO_ID", "Arr[j].PO_ID", "DESC")
                    //  data = this.state.GridData.sort((a, b) => (b.PO_ID > a.PO_ID) ? 1 : -1);
                    break;
                }
                case "REQ_ID": {
                    data = this.sort(this.state.GridData, "Arr[i].REQ_ID", "Arr[j].REQ_ID", "DESC")
                    // data = this.state.GridData.sort((a, b) => (b.REQ_ID > a.REQ_ID) ? 1 : -1);
                    break;
                }
                case "SHIPTO_ID": {
                    data = this.sort(this.state.GridData, "Arr[i].SHIPTO_ID", "Arr[j].SHIPTO_ID", "DESC")
                    // data = this.state.GridData.sort((a, b) => (b.SHIPTO_ID > a.SHIPTO_ID) ? 1 : -1);
                    break;
                }
                case "ISA_WORK_ORDER_NO": {
                    data = this.sort(this.state.GridData, "Arr[i].ISA_WORK_ORDER_NO", "Arr[j].ISA_WORK_ORDER_NO", "DESC")
                    // data = this.state.GridData.sort((a, b) => (b.ISA_WORK_ORDER_NO > a.ISA_WORK_ORDER_NO) ? 1 : -1);
                    break;
                }
                case "ISA_EMPLOYEE_NAME": {
                    data = this.sort(this.state.GridData, "Arr[i].ISA_EMPLOYEE_NAME", "Arr[j].ISA_EMPLOYEE_NAME", "DESC")
                    //data = this.state.GridData.sort((a, b) => (b.ISA_EMPLOYEE_NAME > a.ISA_EMPLOYEE_NAME) ? 1 : -1);
                    break;
                }
                case "INV_ITEM_ID": {
                    data = this.sort(this.state.GridData, "Arr[i].INV_ITEM_ID", "Arr[j].INV_ITEM_ID", "DESC")
                    // data = this.state.GridData.sort((a, b) => (b.INV_ITEM_ID > a.INV_ITEM_ID) ? 1 : -1);
                    break;
                }
            }
        }
        this.setState({ GridData: data })
    }
    /*[98/08/23,User defined sorting], Priyanka D */
    sort = (Arr, indexval, nextindexval, Type) => {
        let temp = []
        let size = Arr.length
        let i, j = 0;

        if (Type == "ASC") {
            for (i = 0; i < size; i++) {
                /* 
                 * Place currently selected element array[i]
                 * to its correct place.
                 */
                for (j = i + 1; j < size; j++) {
                    /* 
                     * Swap if currently selected array element
                     * is not at its correct position.
                     */
                    if (eval(indexval) > eval(nextindexval)) {
                        temp = Arr[i];
                        Arr[i] = Arr[j];
                        Arr[j] = temp;
                    }
                }
            }
            return Arr;
        } else {
            for (i = 0; i < size; i++) {
                /* 
                 * Place currently selected element array[i]
                 * to its correct place.
                 */
                for (j = i + 1; j < size; j++) {
                    /* 
                     * Swap if currently selected array element
                     * is not at its correct position.
                     */
                    if (eval(indexval) < eval(nextindexval)) {
                        temp = Arr[i];
                        Arr[i] = Arr[j];
                        Arr[j] = temp;
                    }
                }
            }
            return Arr;
        }
    }

    FileExport = () => {
        let addFavOrderdataRes = JSON.parse(OpenPOReportStore.Excel);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        //;
        //alert("file downloaded");
    }
    //This Method is used to bind the grid data
    BindGridData = () => {
        return this.state.GridData.map((order, index) => {
            if (index < parseInt(this.state.PageNo) * 10 && index >= parseInt(this.state.PageNo - 1) * 10) {
                return (<React.Fragment key={`key${index}`}>
                    <tr>
                        <td className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)} >
                            <span className="accordion-arrow header-arrow" id={`arrow-${index}`} />
                        </td>
                        <td className="d-md-table-cell"><div style={{ width: '100px' }}><a href="#" className="order-id" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target=".orderstatus-popup" onClick={e => this.getVendorInfo(order)} >{order.PO_ID}</a></div></td>
                        <td className="d-md-table-cell">{order.LINE_NBR}</td>
                        <td className="d-md-table-cell">{order.SCHED_NBR}</td>
                        <td className="d-md-table-cell">{order.INV_ITEM_ID}</td>
                        <td className="d-md-table-cell">{order.DUE_DT}</td>
                        <td className="d-md-table-cell">{order.REQ_DT}</td>
                        <td className="d-md-table-cell">{order.PODT}</td>
                        <td className="d-md-table-cell">{order.ISA_EMPLOYEE_NAME}</td>
                        <td className="d-md-table-cell">{order.REQ_ID}</td>
                        <td className="d-md-table-cell">{order.ISA_WORK_ORDER_NO}</td>
                        <td className="d-md-table-cell">{order.SHIPTO_ID}</td>
                    </tr>
                    <tr className="p d-none content-row" id={`contentrow-${index}`}>
                        <td colSpan="16" className="hiddenRow" id="order-row-1">
                            <div className="p-2" id={`order-row-${index}`}>
                                {this.state.totalCount > 0 ? <React.Fragment>
                                    <h4 className="float-left">Item details</h4>
                                    {this.bindOrderLineItems(order.PO_ID, order.LINE_NBR, order.SCHED_NBR)}
                                </React.Fragment> : `No line items are present in this order`}
                            </div>
                        </td>
                    </tr>
                </React.Fragment>);
            }
        })
    };
    //This method gets the Item Id and Order NO as parameters and binds the line items based on the Item Id and Order NO
    bindOrderLineItems = (PO_ID, LINE_NBR, SCHED_NBR) => {

        let childItems = this.state.GridData.filter((item, index) => item.PO_ID == PO_ID && item.LINE_NBR == LINE_NBR && item.SCHED_NBR == SCHED_NBR);
        return childItems.map((childItem, childindex) => {
            return (<div className="col-md-12 float-left mx-0 mb-3 pt-3 pb-2" key={childindex}>
                <div className="accordian-body  py-1 mt-3 ml-4 pl-2" id="order-row-1">
                    <div className="row mx-0 pb-0">
                        <div className="col-md-10 pl-4 mb-1" style={{ "marginTop": "2px", "marginBottom": "2px" }}>
                            <div className="row">
                                <div className="col-md-10 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Description:</label>
                                    <label className="item-details-value">{childItem.DESCR254_MIXED}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">MFG:</label>
                                    <label className="item-details-value mb-2">{childItem.MFG_ID}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">MFG part num:</label>
                                    <label className="item-details-value mb-2">{childItem.MFG_ITM_ID}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">PO QTY:</label>
                                    <label className="item-details-value mb-2">{childItem.QTY_PO}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">RCV QTY:</label>
                                    <label className="item-details-value mb-2">{childItem.QTY_LN_ACCPT}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Price PO:</label>
                                    <label className="item-details-value mb-2">{childItem.PRICE}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Ext. price:</label>
                                    <label className="item-details-value mb-2">{childItem.EXTPRICE}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Currency:</label>
                                    <label className="item-details-value mb-2">{childItem.CURRENCY_CD}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Vendor name:</label>
                                    <label className="item-details-value mb-2">{childItem.VENDOR_NAME}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Buyer ID:</label>
                                    <label className="item-details-value mb-2">{childItem.BUYER_ID}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Ship date:</label>
                                    <label className="item-details-value mb-2">{childItem.ASN_SHIP_DT}</label>
                                </div>
                                <div className="col-md-4 pr-0 mb-2">
                                    <label className="catalog-label mr-2">Comments:</label>
                                    <label className="item-details-value mb-2">{childItem.NOTES}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>)

        })
    };

    render() {
        const { t } = this.props;
        return (
            <div>
                <div className="container-fluid content-margin content-section custom-mb">

                    <div className="row">
                        <div className="col-md-12 page-heading mb-3">
                            <h5 className="page-title"><Trans>Open POs</Trans></h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-OrdStatus">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>
                        </div>
                        <div className="col-md-12 ">
                            <div className="row align-items-center">
                                <div className="col-md-4 col-lg-2 mb-3">
                                    <label className="catalog-label"><Trans>Select report (by PO date)</Trans></label>
                                    <select className="form-control" name="SelectedReport" value={this.state.SelectedReport} onChange={e => this.OnHandleChange(e, "SelectedReport")}>

                                        <option value="X">{t("Select ReportKey")}</option>
                                        <option value="7">{t("Last 7 Days")}</option>
                                        <option value="15">{t("Last 15 Days")}</option>
                                        <option value="30">{t("Last 30 Days")}</option>
                                        <option value="0">{t("This Month")}</option>
                                        <option value="-1">{t("Last Month")}</option>
                                        <option value="99">Search Transaction</option>
                                    </select>
                                </div>
                                { /*[04/29/22,PC_WW-393_08], Priyanka D */}
                                <div className="col-md-4 col-lg-2 mb-3">
                                    <div className="row">
                                        <label className="col-md-6 catalog-label">Ship To</label>
                                        <div style={{ "fontSize": "14px" }} className="col-md-12"><Select
                                            id="ShipTo"
                                            placeholder="Select ship to" /*PC_WW_723_04 - aded a placeholder - 18/08/23 - Vishwa S*/
                                            options={this.state.ShipToDropdown}
                                            value={this.state.selectedShipTo}
                                            onChange={(e) => this.handleShipTo(e)}
                                        /></div>
                                    </div>
                                </div>
                                {/*<div className="col-md-3 col-lg-2 pl-4 ml-2">{/*WW-251**/}
                                {/*<div className="row align-items-center">
                                        <input type="checkbox" className="custom-checkbox" id="ul" name="ul" checked={this.state.DataLimitCheckbox} onChange={e => this.OnHandleChange(e, "DataLimit")} />
                                        <label className="catalog-label ml-2 mt-2" htmlFor="ulfor"><Trans>Unlimited results</Trans></label>
                                    </div>
                                </div>*/}

                                <div className="col-md-12 col-sm-auto col-auto col-lg-auto mt-3 pb-1 text-right">
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4" onClick={this.SearchCriteriaCheck}><Trans>Apply</Trans><span> </span> <Trans>filter</Trans></button>
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-3" id="ClearBtnID" style={{ width: '115px', marginLeft: '10px' }} onClick={this.DDClear}><Trans>Clear</Trans></button> {/*PC_WW_723_05 - Created a Clear button to clear all the dropdown's selected options - 18/08/23 - Vishwa S*/}
                                    {/* <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-3" ><Trans>Save</Trans><span> </span> <Trans>Preference</Trans></button>*/}
                                </div>

                            </div>

                            <div className="row mb-3" >
                                {this.state.SelectedReport == "99" ? <>
                                    <div className="col-md-3 pr-0 middle-field mb-3" id="sFT" style={{ marginTop: "1%" }}>
                                        <div className="col-md-6 float-left mb-4 p-0 ssd">
                                            <label className="catalog-label"><Trans>From</Trans></label>
                                            <DatePicker className="form-control place"
                                                id="From"
                                                fixedHeight
                                                placeholderText="MM/DD/YYYY"
                                                dateFormat="MM/dd/yyyy"
                                                showMonthDropdown
                                                showYearDropdown
                                                selected={this.state.FromDate}
                                                maxDate={this.state.ToDate}
                                                onChange={(e) => this.OnHandleChange(e, "FromDate")}
                                            //value={this.state.FromDate}
                                            />

                                            {/* K. surya Calendar icons issue bug fix - 12/5/2024*/}
                                            <span className="calendar-icon filter-calendar-icon open-po-calendar float-left" onClick={() => $(`#From`).focus()} />

                                        </div>
                                        <div className="col-md-6 float-left mb-4 pr-0 pl-1 ssd section-content-padding">
                                            <label className="catalog-label">To <span className="info-container"><img className="info-searchpage" src="Images/info-icon.png" /><span className="info-content info-position"><Trans>Date range is limited to 3 months</Trans></span></span></label>
                                            <DatePicker className="form-control place "
                                                id="To"
                                                fixedHeight
                                                placeholderText="MM/DD/YYYY"
                                                dateFormat="MM/dd/yyyy"
                                                showMonthDropdown
                                                showYearDropdown
                                                selected={this.state.ToDate}
                                                minDate={this.state.FromDate}
                                                onChange={(e) => this.OnHandleChange(e, "ToDate")}
                                            //value={this.state.ToDate}
                                            />

                                            {/* K. surya Calendar icons issue bug fix - 12/5/2024*/}
                                            <span className="calendar-icon filter-calendar-icon open-po-calendar float-left" onClick={() => $(`#To`).focus()} />

                                        </div>
                                    </div>


                                    <div className="col-md-3 pr-0 left-field mb-3" id="sdrp">
                                        

                                            <div className="input-group dropdown-search float-left mb-2 w-100" style={{ "paddingTop": "40px" }}>
                                                <div className="input-group-prepend">
                                                    <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >{this.state.SearchBy}</button>
                                                    <div className="dropdown-menu" style={{}}>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.OnHandleChange(e, "SearchBy", "PO Number")}><Trans>PO Number</Trans></a>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.OnHandleChange(e, "SearchBy", "Order Number")}><Trans>Order Number</Trans></a>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.OnHandleChange(e, "SearchBy", "Item Description")}><Trans>Item Description</Trans></a>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.OnHandleChange(e, "SearchBy", "Work Order")}><Trans>Work Order</Trans></a>
                                                        {/*Remove Machine number and Charge code form filters- TFS-BUG-4042*/}
                                                        {/* <a className="dropdown-item" href="#" onClick={(e) => this.OnHandleChange(e, "SearchBy", "Machine Number")}><Trans>Machine Number</Trans></a>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.OnHandleChange(e, "SearchBy", "Charge Code")}><Trans>Charge Code</Trans></a>*/}
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.OnHandleChange(e, "SearchBy", "Item ID")}><Trans>Item ID</Trans></a>
                                                    </div>
                                                </div>
                                                 
                                            <input type="text" className="form-control " placeholder="Search" aria-label="Text input with dropdown button" value={this.state.SearchCriteria} onChange={e => this.OnHandleChange(e, "SearchCriteria")} id="SearchCriteria" maxLength={254} />
                                            {/* 5727 - added a clear icon 4/30/2025  Nachiappan */}
                                            <span className={this.state.SearchCriteria != null && this.state.SearchCriteria != undefined && this.state.SearchCriteria != "" ? "search-cancel-header-openpo cursor-pointer" : "d-none"} onClick={() => this.setState({ SearchCriteria: "" })} style={{ "float": "left" }}></span>
                                            </div>
                                       
                                    </div>
                                    {/*</div>*/}
                                    {/*<div className="W-100 p-0 float-right mt-3">*/}
                                    <div className="col-md-3 pr-0 left-field mb-3" id="sdrp" style={{ "paddingTop": "40px" }}>
                                        <div className="input-group dropdown-search float-left mb-2 w-100">
                                            <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-right">
                                                {/*<input type="checkbox" className="custom-control-input" id="FirstPOOnly" name="FirstPOOnly" checked={this.state.UseDateRangeCheckbox} onChange={e => this.OnHandleChange(e, "UseDateRangeCheckbox")} />
                                                <label className="custom-control-label float-left" htmlFor="FirstPOOnly" />


                                                {/* <label className="catalog-label float-left mt-1 space-check " htmlFor="FirstPOOnly"><Trans>Use date range entered above to limit search</Trans></label>*/}
                                            </div>
                                        </div>
                                    </div>

                                    {/* </div>
                                                </div>
                                                </div>*/}
                                </> : null}


                            </div>

                            <div className="row border-top ">
                                {/* <div className="col-md-12 mb-2">
                                            <div className="float-right">{this.state.totalCount > 0 ? <>*/}
                                {/*<button className="btn btn-primary custom-btn-primary primary-btn float-left mr-3" onClick={this.addFavItemsToCart}><Trans>Buy Checked Items</Trans></button>*/}
                                {/*<button className="btn btn-primary custom-btn-primary primary-btn float-left mr-3" onClick={this.expandAll}><Trans>{!this.state.isExpand ? `Expand All` : `Collapse All`}</Trans></button>*/}
                                {/* <button className="btn btn-primary custom-btn-primary primary-btn float-left " onClick={e => this.export()}><Trans>Export to Excel</Trans></button></> : null}
                                            </div>
                                        </div>*/}

                                <div className="col-md-12 col-sm-auto col-auto mb-3 pt-3 text-right">{this.state.totalCount > 0 ? <>
                                    {/*<button className="btn btn-primary custom-btn-primary primary-btn float-left mr-3" onClick={this.addFavItemsToCart}><Trans>Buy Checked Items</Trans></button>*/}
                                    {/*<button className="btn btn-primary custom-btn-primary primary-btn float-left mr-3" onClick={this.expandAll}><Trans>{!this.state.isExpand ? `Expand All` : `Collapse All`}</Trans></button>*/}
                                    <button className="btn btn-primary custom-btn-primary primary-btn" onClick={e => this.export()}><Trans>Export to Excel</Trans></button></> : null}
                                </div>

                                {this.state.ShowGrid ?
                                    <div className="col-md-12">
                                        <div classsName="col-md-12">
                                            <div className="table-responsive">
                                                <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                                    <thead>
                                                        <tr>
                                                            <th />
                                                            <th className="d-md-table-cell position-sort-icon"><Trans>SDI PO (Vendor info)</Trans><span className="sort-up1 ml-1" onClick={(e) => this.Sorting("A", "PO_ID")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("D", "PO_ID")}><img src="Images/sort1.svg" /></span></th>
                                                            <th className="d-md-table-cell position-sort-icon"><Trans>Ln #</Trans></th>
                                                            <th className="d-md-table-cell position-sort-icon"><Trans>Sch #</Trans></th>
                                                            <th className="d-md-table-cell position-sort-icon"><Trans>Item ID</Trans><span className="sort-up1 ml-1" onClick={(e) => this.Sorting("A", "INV_ITEM_ID")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("D", "INV_ITEM_ID")}><img src="Images/sort1.svg" /></span></th>
                                                            <th className="d-md-table-cell position-sort-icon"><Trans>Due date</Trans></th>
                                                            <th className="d-md-table-cell position-sort-icon"><Trans>Required by date	</Trans></th>
                                                            <th className="d-md-table-cell position-sort-icon"><Trans>PO DT</Trans></th>
                                                            <th className="d-md-table-cell position-sort-icon"><Trans>Emp name</Trans><span className="sort-up1 ml-1" onClick={(e) => this.Sorting("A", "ISA_EMPLOYEE_NAME")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("D", "ISA_EMPLOYEE_NAME")}><img src="Images/sort1.svg" /></span></th>
                                                            <th className="d-md-table-cell position-sort-icon"><Trans>Order no</Trans><span className="sort-up1 ml-1" onClick={(e) => this.Sorting("A", "REQ_ID")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("D", "REQ_ID")}><img src="Images/sort1.svg" /></span></th>
                                                            <th className="d-md-table-cell position-sort-icon"><Trans>W/O Num</Trans><span className="sort-up1 ml-1" onClick={(e) => this.Sorting("A", "ISA_WORK_ORDER_NO")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("D", "ISA_WORK_ORDER_NO")}><img src="Images/sort1.svg" /></span></th>
                                                            <th className="d-md-table-cell position-sort-icon"><Trans>Ship To</Trans><span className="sort-up1 ml-1" onClick={(e) => this.Sorting("A", "SHIPTO_ID")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("D", "SHIPTO_ID")}><img src="Images/sort1.svg" /></span></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.totalCount > 0 ? this.BindGridData() :
                                                            (

                                                                <tr>
                                                                    <td colSpan={11}>
                                                                        <section className="site-undercontruction container text-center center-panel pt-4">
                                                                            <div className="img-section">
                                                                                <img src="images/nosearch.jpg" alt="imagefile" />
                                                                            </div>
                                                                            <p className="search-result-content pt-4"><Trans>Sorry, we couldn’t find any search result</Trans>
                                                                            </p>
                                                                        </section>
                                                                    </td>
                                                                </tr>)}

                                                    </tbody>
                                                </table>


                                            </div>
                                        </div>
                                    </div> : null}

                                {this.state.GridData.length > 0 ?
                                    <div className="col-md-12">
                                        <span className="total-records mt-2 d-inline-block">
                                            <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.GridData.length}</span>
                                        </span>
                                        {this.state.GridData.length > 10 ? <ReactPaginate
                                            previousLabel={<span className="right-pagination-arrow" />}
                                            nextLabel={<span className="left-pagination-arrow" />}
                                            previousClassName={'page-item'}
                                            nextClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextLinkClassName={'page-link'}
                                            disabledClassName={'disabled'}
                                            breakLabel={'...'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            pageCount={this.state.PageCount}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={2}
                                            onPageChange={e => this.handlePageClick(e)}
                                            containerClassName={'custom-pagination pagination float-right'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                            hrefBuilder={() => '#'}
                                            forcePage={this.state.PageNo - 1}
                                        /> : null}

                                    </div> : null}

                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal" id="VendorDetail" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1">Vendor detail</h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body" >
                                <div className="row" style={{ flexWrap: 'nowrap', width: '70%' }}>
                                    <div className="col-md-12 edit-desc-field mb-4 " style={{ marginLeft: '5%', marginRight: '0%' }}>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label">Vendor ID</label>
                                            <label className="col-md-7 quick-value">{this.state.PopupVendorDetail.VendorID}</label>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label">Vendor Loc</label>
                                            <label className="col-md-7 quick-value">{this.state.PopupVendorDetail.VendorLoc}</label>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label">Addr Seq</label>
                                            <label className="col-md-7 quick-value">{this.state.PopupVendorDetail.AddressSeqNum}</label>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label">Vendor</label>
                                            <label className="col-md-7 quick-value">{this.state.PopupVendorDetail.Name}</label>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label">Address</label>
                                            <label className="col-md-7 quick-value">{`${this.state.PopupVendorDetail.Address1}`}</label>
                                            <label className="col-md-7 quick-value">{this.state.PopupVendorDetail.Address2}</label>
                                            <label className="col-md-7 quick-value">{this.state.PopupVendorDetail.Address3}</label>
                                            <label className="col-md-7 quick-value">{this.state.PopupVendorDetail.Address4}</label>
                                        </div>

                                    </div>
                                    <div className="col-md-12 edit-desc-field mb-4" style={{ margin: '0%' }}>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label"><Trans>City</Trans></label>
                                            <label className="col-md-7 quick-value">{this.state.PopupVendorDetail.City}</label>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label">State</label>
                                            <label className="col-md-7 quick-value">{this.state.PopupVendorDetail.State}</label>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label">ZipCode</label>
                                            <label className="col-md-7 quick-value">{this.state.PopupVendorDetail.Postal}</label>
                                        </div>

                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label">Contact</label>
                                            <label className="col-md-7 quick-value">{this.state.PopupVendorDetail.ContactName}</label>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label"><Trans>Phone</Trans></label>
                                            <label className="col-md-7 quick-value">{`${this.state.PopupVendorDetail.Phone}(${this.state.PopupVendorDetail.Phonetype})`}</label>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withTranslation()(OpenPOReportComponent);